import React from 'react'
import { Link } from 'react-router-dom'

import { ROUTES } from 'helpers/constants'

const adminRoutes = [
  {
    title: 'Waitlist',
    path: ROUTES.ADMIN_WAITLIST,
  },
  {
    title: 'Matches',
    path: ROUTES.ADMIN_MATCHES,
  },
  {
    title: 'Active Users',
    path: ROUTES.ADMIN_ACTIVE_USERS,
  },
  {
    title: 'Events',
    path: ROUTES.HOST_PORTAL,
  },
  {
    title: 'Analytics',
    path: ROUTES.ADMIN_ANALYTICS,
  },
]
const AdminPortal = () => {
  return (
    <div className="flex flex-col items-center justify-center bg-white h-screen-less-navbar-m w-full px-4 md:h-screen-less-navbar md:px-10">
      <h1 className="text-center text-5xl mb-10">Admin Portal</h1>
      <div className="flex flex-wrap justify-center">
        {adminRoutes.map(({ title, path }) => (
          <Link
            key={path}
            to={path}
            className="flex items-center justify-center w-32 h-32 bg-blue-500 mr-5 mb-5 text-black text-center text-xl px-4 font-semibold hover:opacity-80 hover:text-black"
          >
            {title}
          </Link>
        ))}
      </div>
    </div>
  )
}

export default AdminPortal
